/* eslint-disable */
// @ts-nocheck
import { ghb } from "@cervval.js/i18n/src/i18n.tools";

export const i18n = {
    allSaved: "Toutes les modifications ont été enregistrées",
    clearBtn: {
        label: "Forcer le rechargement des données"
    },
    offline: "Hors ligne - toutes les modifications ont été enregistrées",
    pending: ghb({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "Enregistrement en attente de "
    + container.escapeExpression((lookupProperty(helpers,"pluralCount")||(depth0 && lookupProperty(depth0,"pluralCount"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"actionCount") : depth0),"action",{"name":"pluralCount","hash":{},"data":data,"loc":{"start":{"line":1,"column":29},"end":{"line":1,"column":65}}}))
    + " avec "
    + container.escapeExpression((lookupProperty(helpers,"pluralCount")||(depth0 && lookupProperty(depth0,"pluralCount"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"operationCount") : depth0),"modification",{"name":"pluralCount","hash":{},"data":data,"loc":{"start":{"line":1,"column":71},"end":{"line":1,"column":116}}}))
    + "...";
},"useData":true}),
    redo: "Refaire",
    refreshBtn: {
        label: "Actualiser"
    },
    sending: ghb({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "Enregistrement en cours de "
    + container.escapeExpression((lookupProperty(helpers,"pluralCount")||(depth0 && lookupProperty(depth0,"pluralCount"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"actionCount") : depth0),"action",{"name":"pluralCount","hash":{},"data":data,"loc":{"start":{"line":1,"column":27},"end":{"line":1,"column":63}}}))
    + " avec "
    + container.escapeExpression((lookupProperty(helpers,"pluralCount")||(depth0 && lookupProperty(depth0,"pluralCount"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"operationCount") : depth0),"modification",{"name":"pluralCount","hash":{},"data":data,"loc":{"start":{"line":1,"column":69},"end":{"line":1,"column":114}}}))
    + "...";
},"useData":true}),
    undo: "Annuler"
};